export class SearchCondition {
  user_name: string = ""
  course_code: string = null
  campus_code: string = null
  class_code: string = null
  page: number = 1
  row_count: number =  100
}

export class UserScorableRange {
  id: number
  login_id: string
  nendo: number
  user_name: string
  course_codes: string
  campus_codes: string
  class_codes: string
  subject_codes: string
  full_count: number
  is_checked: boolean = false

  constructor(x: any){
    this.id = x.id
    this.login_id = x.login_id
    this.nendo = x.nendo;
    this.user_name = x.user_name
    this.course_codes = x.course_codes
    this.campus_codes = x.campus_codes
    this.class_codes = x.class_codes
    this.subject_codes = x.subject_codes
    this.full_count = x.full_count;
  }
}